import React, { useEffect } from 'react';
import ContentGrid from '../contentGrid';
import Footer from '../footer/footer';
import FooterMobile from '../footer/footerMobile';

const Layout = ({
  orderData,
  apticDirectInvoiceLetterId,
  footerData,
  merchantData,
  onValidateLink
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const view = urlParams.get('view');

  useEffect(() => {
    window.parent.postMessage({ action: 'getStyles' }, '*');
  }, []);

  const handleMessage = (event) => {
    if (event.data.action === 'setStyles') {
      const ordoMainDiv = document.getElementById('ordo-ui-main');
      if (!!event.data?.payload?.backgroundColor)
        ordoMainDiv.style.backgroundColor = event.data.payload.backgroundColor;
      if (!!event.data?.payload?.fontFamily)
        ordoMainDiv.style.fontFamily = event.data.payload.fontFamily;
    }
  };

  useEffect(() => {
    const onMessage = (event) => {
      handleMessage(event);
    };
    window.addEventListener('message', onMessage);
  }, [handleMessage]);
  return (
    <div>
      {/* Body */}
      <ContentGrid
        data={orderData}
        apticDirectInvoiceLetterId={apticDirectInvoiceLetterId}
        merchantData={merchantData}
        onValidateLink={onValidateLink}
      />

      {/* Footer */}
      {!view || view === 'full' ? (
        <>
          <Footer
            data={footerData}
            onValidateLink={onValidateLink}
            className="d-lg-block"
          />
          <FooterMobile
            data={footerData}
            onValidateLink={onValidateLink}
            className="d-lg-none"
          />
        </>
      ) : null}
    </div>
  );
};

export default Layout;
